/**
 * This function is used to convert bytes to a human-readable string.
 * @param bytes
 * @returns
 */
export function getFileSizeString(bytes: number) {
	if (bytes < 0) return getFileSizeString(0);
	if (bytes < 1_024) return getByteString(bytes);
	if (bytes < 1_048_576) return getKilobyteString(bytes);
	if (bytes < 1_073_741_824) return getMegabyteString(bytes);
	return getGigabyteString(bytes);
}

/**
 * This function converts bytes to a human-readable string.
 * @param bytes
 * @returns
 */
function getByteString(bytes: number) {
	return `${bytes.toFixed(0)} Byte`;
}

function getGigabyteString(bytes: number) {
	if (bytes < 0) return getGigabyteString(0);
	return `${(bytes / 1_073_741_824).toFixed(2)} GB`;
}

/**
 * This function converts bytes to megabytes.
 * @param bytes
 * @returns
 */
function getMegabyteString(bytes: number) {
	if (bytes < 0) return getMegabyteString(0);
	return `${(bytes / 1_048_576).toFixed(2)} MB`;
}

/**
 * This function converts bytes to kilobytes.
 * @param bytes
 * @returns
 */
function getKilobyteString(bytes: number) {
	return `${(bytes / 1_024).toFixed(2)} KB`;
}

/**
 * This function extracts the file name from a file path.
 * @param filePath
 * @returns
 */
export function getFileName(filePath: string) {
	const parts = filePath.split("/");
	const fileName = parts[parts.length - 1];
	return fileName;
}
